import { cilMediaSkipBackward } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CButton, CImg, CRow } from '@coreui/react';
import * as React from 'react';
import { Redirect } from 'react-router';
import { IBackupProvider, IImageProvider, IMenuTab, IMenuTabItem, MenuActionEnum } from '../abstraction';
import { AppLabels } from '../core/AppLabels';
import { KWidgetsPanel } from './KWidgetsPanel';

interface IProps {
	menutabs: IMenuTab[];
	onMenuClick: (item: IMenuTabItem) => void;
	menu: string;
	imageProvider: IImageProvider;
	backupProvider: IBackupProvider; // permet de pouvoir sauvegarder la configuration d'affichage
}

interface IState {
	redirectTo: string;
	currentTab: IMenuTab;
	currentNode: IMenuTabItem;
	refreshToken: number;
	collapse: boolean;
}
// Représente le composant gérant les onglets du menu général
export class KTabMenu extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);
		let node: IMenuTabItem = null;
		// Si un code menu a été spécifié via l'url :
		if (this.props.menu != "") node = this.findMenuInTabs(this.props.menu)

		this.state = {
			redirectTo: "",
			currentTab: this.props.menutabs[0],
			currentNode: node,
			refreshToken: Math.random(),
			collapse: false,
		};
	}

	// Recherche un menu dans les différens onglets
	findMenuInTabs = (code: string): IMenuTabItem => {
		let node: IMenuTabItem = null;

		// Balaye chaque noeud racine de l'onglet et regarde lance une recherche récursive du menu
		this.props.menutabs[0].items.map(i => {
			if (node == null) node = this.findMenuItem(code, i);
		});

		// Soit on l'a trouvé et on retourne le noeu, soit c'est null
		return node;
	}

	// Cherche un menu dans l'arborescence des menus (récursif)
	findMenuItem = (code: string, node: IMenuTabItem): IMenuTabItem => {
		if (node == null) return null;
		if (node.id == code) return node;

		// parcours les enfants à la recherche du menu
		// Récursif. Si trouvé, on retourne le noeud
		node.children.map(c => {
			let found = this.findMenuItem(code, c);
			if (found) return found;
		});

		// Not found
		return null;
	}

	//#region React Hacks

	// Dans le cas où les props changent, on ne repasse pas par le constructeur
	// Il faut donc mettre à jour l'état
	UNSAFE_componentWillReceiveProps = (nextProps: IProps) => {
		if (nextProps.menu != "") {
			this.setState({ currentNode: this.findMenuInTabs(nextProps.menu) });
		}
		else {
			this.setState({ currentNode: null })
		}
	}
	//#endregion 

	//#region Local events

	// 
	// noAction = 0, link = 1, submenu = 2, up=3
	// 
	menuItemClick = (item: IMenuTabItem) => {
		if (item.target != "") {

			//Si ça ne commence pas par un /
			if (!item.target.startsWith("/")) {

				// Si on est dans le cas d'un sous-menu, on met l'url à jour avec le nouveau menu
				if (item.action == MenuActionEnum.submenu) {
					window.history.pushState("", "", "/Home/" + item.id);
				}

				this.setState({ currentNode: item });
			}
		}

		// On transmet le clic
		// C'est l'appelant qui gère un branchement vers une fonction
		if (this.props.onMenuClick) this.props.onMenuClick(item);
	}

	// Clic sur bouton précédent
	OnPreviousClick = () => {
		let parent = this.findMenuInTabs(this.state.currentNode.idParent);

		if (parent != null) {
			if (parent.id != "") window.history.pushState("", "", "/Home/" + parent.id);
		}
		else window.history.pushState("", "", "/");

		this.setState({
			currentNode: parent
		});

		this.forceUpdate();
	}

	//#endregion Local events

	//#region Rendus

	// Rendu du bouton précédent
	renderPrevious = () => {
		if (this.state.currentNode)
			if (this.state.currentNode.idParent)
				return <CButton onClick={this.OnPreviousClick}>
					<CIcon content={cilMediaSkipBackward} /> {AppLabels.previous}
				</CButton>
		return "";
	}

	renderMenuItem = (item: IMenuTabItem) => {
		return (
			<div key={item.id} id={item.id} data-idparent={item.idParent} className='MenuItem' onClick={() => this.menuItemClick(item)} >
				<CImg src={this.props.imageProvider.getImg(item.imgCode)} /><br />
				{item.text}
			</div>
		);
	}




	// Rendu principal
	render() {
		// En cas de clic sur un bouton impliquant une redirection, on fait direct le redirect
		let currentNode = this.state.currentNode;
		let currentTab = this.state.currentTab;
		if (this.state.redirectTo != "") return <Redirect to={this.state.redirectTo}></Redirect>;

		let title = AppLabels.viewHomeTitle;
		if (currentNode) title = currentNode.text;

		let widgets = (!currentNode) ?
			currentTab.items.filter(x => x.action == MenuActionEnum.widget)
			:
			currentNode.children.filter(x => x.action == MenuActionEnum.widget);

		let tab = (!currentNode) ?
			currentTab.items.filter(x => x.action != MenuActionEnum.widget).map((item) => this.renderMenuItem(item))
			:
			currentNode.children.filter(x => x.action != MenuActionEnum.widget).map((item) => this.renderMenuItem(item));
		return (
			<React.Fragment>
				<div className="KBreadcrum "><span>{title}</span></div>

				<CRow>
					<div className="MenuPanel" id="menu" >
						{tab}
					</div>
				</CRow>

				<div className="Previous">
					{this.renderPrevious()}
				</div>

				<KWidgetsPanel tabItems={widgets} id={(!currentNode) ? currentTab.id : currentNode.id} backupProvider={this.props.backupProvider} />

			</React.Fragment>
		);
	}

	//#endregion

}
